module.exports = __webpack_public_path__ + "static/img/3_4_1.ec881053.jpg";